<script>
import { sortBy } from 'lodash';
import { mapActions } from 'vuex';
import IntentsControl from 'src/pages/Client/shared/IntentsControl';
import { isEmpty, appendIndexForEachElement } from 'src/utils';
import { eventBus } from 'src/features';
import { requiredRule } from 'src/utils/helper';

async function getRequestType(vm) {
  return await vm.getAllRequestTypes({ onlyActive: true });
}

export default {
  props: ['value'],
  async mounted() {
    const allRequestTypes = await getRequestType(this);
    if (!isEmpty(allRequestTypes)) {
      this.requestTypes = appendIndexForEachElement([
        { header: this.$t('T_REQUEST_TYPES') },
        ...sortBy(allRequestTypes, (rt) => rt.title.toLowerCase()),
      ]);
    }
  },
  components: {
    IntentsControl,
  },
  data() {
    return {
      header: this.value.header,
      caseTheme: {
        name: '',
        description: '',
        rtIndex: null,
      },
      requestTypes: [],
      selectedRequestTypeId: null,
      errors: {
        name: [],
        description: [],
        requestType: [],
      },
      rules: {
        required: requiredRule,
      },
    };
  },
  methods: {
    ...mapActions('operator', ['getAllRequestTypes']),
    ...mapActions('activities', ['createCaseFromActivity']),
    select(rt) {
      this.errors.requestType = [];
      this.$emit('select', this.requestTypes[rt]);
      if (rt) {
        this.selectedRequestTypeId = this.requestTypes[rt].id;
      }
    },
    async locCreateCase() {
      Object.keys(this.caseTheme).forEach((f) => {
        this.$refs[f].validate(true);
      });
      this.$refs.newCaseForm.withErrorHandling(async () => {
        const { activityId } = this.value;
        const caseInput = {
          name: this.caseTheme.name,
          description: this.caseTheme.description,
        };
        const requestTypeId = parseInt(this.selectedRequestTypeId, 10);
        await this.createCaseFromActivity({
          activityId,
          requestTypeId,
          case: caseInput,
        });
        eventBus.$emit('createCaseFromActivity', activityId);
        this.close();
      });
    },
    close() {
      this.$parent.close([null]);
    },
    resolve(answer) {
      if (answer) {
        this.locCreateCase();
      }
      this.close();
    },
  },
};
</script>

<template lang="pug">
div(:class="$style.root")
  header(:class="$style.header")
    div(:class="$style.headerTitle", data-test="NEW_CASE") {{ header }}
  vc-form(ref="newCaseForm", @submit="locCreateCase", hidden)
    div(:class="$style.content")
      v-text-field#name(
        :class="$style.required"
        :label="$t('T_NAME_CASE')",
        ref="name",
        v-model="caseTheme.name",
        :error-messages="errors.name",
        @input="errors.name = []",
        :rules="[rules.required]"
        required)
      v-text-field#description(
        :class="$style.required"
        :label="$t('T_DESCRIPTION')",
        ref="description",
        v-model="caseTheme.description",
        :error-messages="errors.description",
        @input="errors.description = []",
        :rules="[rules.required]"
        required)
      v-select#request-type(
        :class="$style.required"
        :label="$t('T_SELECT_REQUEST_TYPE')",
        :error-messages="errors.requestType",
        ref="rtIndex",
        v-model="caseTheme.rtIndex",
        :items="requestTypes",
        item-text="title",
        item-value="index",
        max-height="auto",
        @select="select",
        @input="select",
        :menu-props="{ zIndex: 10009}"
        :rules="[rules.required]"
        required)
    div(:class="$style.action", date-test="REPLY_BUTTON")
      ui-button(colored="green", @submit="locCreateCase", @keyup.enter.native="locCreateCase",
        data-test="SEND_CASE") {{ $t('T_SEND') }}
      ui-button(colored="red", @click.native="close", @keyup.enter.native="close",
        data-test="CANCEL_SEND_CASE") {{ $t('T_CANCEL') }}
</template>

<style lang="sass" module>
.root
  display: block
.header
  padding: 24px
  border-bottom: 1px solid $color_divider
  &Title
    font-size: 18px
    display: flex
    justify-content: center
.content
  display: flex
  flex-direction: column
  padding: 24px
  min-width: 532px
  height: 386px
  flex: 1 1 100%
.action
  display: flex
  padding: 24px
  justify-content: space-around

.required label::after
    content: "*"
    color: $color_red
</style>
